import React from 'react';

const DotLoader = () => {
  return (
    <div className="col-3">
      <div className="snippet" data-title="dot-pulse">
        <div className="stage">
          <div className="dot-pulse"></div>
        </div>
      </div>
    </div>
  );
};

export default DotLoader;